import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorPage from '@/views/pages/404Page';
import { GuardedPageRoute } from '../routeGuards';
import {
  GameListCreatePage,
  GameListEditPage,
  GameListPage,
  GameListViewPage,
} from '../lazyPages';

export const GamesListRoutes = () => {
  const { t } = useTranslation();
  return (
    <Routes>
      <Route
        index
        element={
          <GuardedPageRoute pageName={t('STAFF_SIDEBAR.GAME_LIST')}>
            <GameListPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="create"
        element={
          <GuardedPageRoute
            pageName={t('GAME_LIST.CREATE_TITLE')}
            action="create"
          >
            <GameListCreatePage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="detail/:id"
        element={
          <GuardedPageRoute pageName={t('GAME_LIST.VIEW_TITLE')}>
            <GameListViewPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="edit/:id"
        element={
          <GuardedPageRoute
            pageName={t('GAME_LIST.EDIT_TITLE')}
            action="update"
          >
            <GameListEditPage />
          </GuardedPageRoute>
        }
      />
      <Route
        path="add/:id"
        element={
          <GuardedPageRoute pageName={t('STAFF_TOPUP')} action="create">
            <GameListPage />
          </GuardedPageRoute>
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
};
